import { Provider } from "@redotech/redo-order-common/provider";
import { createContext } from "react";

// Storefront of the flow being edited, gating provider-specific condition
// options. No default so consumers throw rather than assume Shopify.
export const ConditionProviderContext = createContext<Provider | undefined>(
  undefined,
);
